export default "__VITE_ASSET__CUbEAL5D__"